export default __webpack_public_path__ + "media/images/archetypes/replier-5aa2f20b7fce7f180a5ae08055ff9900.png";